import {
    FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES,
    FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_FAILURE,
    FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_SUCCESS,
} from '../../../actions/types';

export const fetchAccessSessionActivities = (payload) => {
    return {
        type: FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES,
        payload: payload,
    };
};

export const fetchAccessSessionActivitiesFailure = (error) => {
    return {
        type: FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_FAILURE,
        error: error,
    };
};

export const fetchAccessSessionActivitiesSuccess = (payload) => {
    return {
        type: FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/reservations/session/reservationSessionActivities.js